import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

export const routes = [
  {
    path: '/login',
    component: () => import('@/pages/login')
  },
  {
    path: '/error',
    name: 'error',
    component: () => import('@/pages/error')
  },
  {
    path: '/404',
    name: '404',
    component: () => import('@/pages/404')
  },
  {
    path: '/home',
    name: 'home',
    component: () => import('@/pages/home')
  },
  {
    path: '/preview',
    name: 'preview',
    component: () => import('@/pages/preview')
  },
  {
    path: '*',
    name: 'container',
    component: () => import('@/pages/container')
  }
]

export default new VueRouter({
  mode: 'history',
  routes
})
